var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: (_vm.color || 'primary') + '--text' + (_vm.bold ? ' font-weight-bold' : '')
  }, [_vm.v == '' ? [_vm._v("N/A")] : [_c('span', {
    class: _vm.priceClass,
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm.prefix ? [_vm._v(_vm._s(_vm.prefix))] : _vm._e(), _c('currency', {
    attrs: {
      "code": _vm.cur,
      "negative": _vm.v.startsWith('-')
    }
  }), _c('span', [_vm._v(_vm._s(_vm.left))]), _vm.right ? [_c('span', [_vm._v(".")]), _c('div', {
    staticClass: "d-inline-block",
    staticStyle: {
      "font-size": ".5em",
      "line-height": ".5em",
      "vertical-align": "middle",
      "transform-origin": "top left",
      "transform": "translateY(-.5em)"
    },
    domProps: {
      "textContent": _vm._s(_vm.right)
    }
  })] : _vm._e()], 2), _vm.per ? _c('span', {
    class: 'ml-1 caption ' + (_vm.color || 'grey') + '--text' + (_vm.bold ? ' font-weight-bold' : ''),
    staticStyle: {
      "white-space": "nowrap"
    },
    domProps: {
      "innerHTML": _vm._s(' per ' + _vm.per)
    }
  }) : _vm._e()]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }